import React from "react";
import { joinClassnames, mapMultiClassnames } from "utils/map-modifier";
import "./index.scss";

interface RadioProps {
  type: string;
  name: string;
  value: string;
  display?: React.ReactNode;
  selected?: string;
  modifier?: Modifiers;
  refs?: any;
  disabled?: boolean;
  onChange?: (e: any) => void;
}

const Radio: React.FC<RadioProps> = ({
  display,
  modifier,
  refs,
  ...inputProps
}: RadioProps) => {
  const { disabled, onChange, value, selected } = inputProps;

  return (
    <label
      className={joinClassnames(
        mapMultiClassnames("a-radio", modifier),
        disabled && "disabled",
      )}
    >
      <input
        {...inputProps}
        ref={refs}
        onChange={onChange}
        value={value}
        checked={value === selected}
      />
      <div
        className={mapMultiClassnames(
          "a-radio_input",
          value === selected ? "checked" : "unchecked",
        )}
      >
        {value === selected ? <div className="a-radio_input_circle"></div> : ""}
      </div>
      <span className="a-radio_span">{display}</span>
    </label>
  );
};

Radio.defaultProps = {};

export default Radio;
